export default "__VITE_ASSET__ZrewwwLf__"